import React, { useContext, useEffect, useState } from "react";
import { get } from "venuescanner-js/services/api";
import LocationAndRadius from "../fields/LocationAndRadius";
import { formikMuiSelectField } from "venuescanner-js/react/components/MuiFields/muiSelectField";
import EventTypeField from "venuescanner-js/react/components/SelectField";
import classes from "../../styles/styles.module.scss";
import stage0Classes from "../../styles/initialEventDetails.module.scss";
import DateAndTimeField from "../fields/DateAndTimeField";
import FlexibleField from "../fields/FlexibleField";
import { ConfigContext } from "../../context";
import getStages from "../../getStages";
import { StageContext } from "../StageContainer/LazyStageContainer";

const MuiEventTypeField = formikMuiSelectField(EventTypeField);

const getTags = (base) =>
  get(base + "/event-types", { returnData: false }).then(
    (res) => res.event_types
  );

const InitialEventDetailsStage = () => {
  const configContext = useContext(ConfigContext);
  const { base } = configContext;
  const { setStageRepo } = useContext(StageContext);

  const [tags, setTags] = useState(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (!base || load) return;
    setLoad(true);
    getTags(base).then(setTags);
  }, [base, load, setLoad]);

  return (
    <div className={classes.Form}>
      <div className={classes.StageWrapper}>
        <div className={classes.FormControl}>
          <MuiEventTypeField
            name="eventType"
            label="What type of event are you organising?"
            tagData={tags}
            className={stage0Classes.EventTypeField}
            inputProps={{
              "data-ga": `eventType`,
              "data-test-id": "venueSearch-eventTypeField",
            }}
            onChange={({ isCorporate }) => {
              setStageRepo(getStages({ ...configContext, isCorporate }));
            }}
          />
        </div>
        <div className={classes.FormControl}>
          <LocationAndRadius />
        </div>
        <div className={classes.FormControl}>
          <DateAndTimeField />
          <FlexibleField />
        </div>
      </div>
    </div>
  );
};

export default InitialEventDetailsStage;
